import { withInstall } from '@sgui-plus/utils'
import MultiFilter from './src/multi-filter.vue'

export const SgMultiFilter = withInstall(MultiFilter)
export default SgMultiFilter

export * from './src/multi-filter'
